import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import {
  ExitIntentRequest,
  MotorDataDataService
} from "src/app/share/data-service/motor.data.service";
import { MotorQuotationDataService } from "src/app/share/data-service/motor/motor-quotation.data.service";
import { SystemLOVInterface } from "src/app/share/interface/motor.interface";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
  selector: "app-exitIntent-dialog",
  templateUrl: "./exit-intent-dialog.component.html",
  styleUrls: ["./exit-intent-dialog.component.scss"]
})
export class ExitIntentDialogComponent implements OnInit {
  selectedReasonId?: string;
  customReason?: string;
  exitIntentForm?: ExitIntentRequest;
  motorLinkId?: string;
  reasonList?: SystemLOVInterface[];
  currentStep: number = 1;
  isSubmitting: boolean = false;
  othersReasonId = 'dea2d075-1dc5-4120-a050-e4e447ff400c';
  @Output() submitForm = new EventEmitter<boolean>();
  @Output() continueForm = new EventEmitter<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: {
      motorLinkId: string;
    },
    private dialogRef: MatDialogRef<ExitIntentDialogComponent>,
    private motorDataDataService: MotorDataDataService
  ) {}

  ngOnInit(): void {
    this.getReasonListFromSystemLOV();
  }

  submit() {
    if (!this.data?.motorLinkId || !this.selectedReasonId) return;

    // Always go to Step 2 regardless of reason selected
    this.currentStep = 2;
  }

  submitCustomReason() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    this.submitFeedback();
  }

  private submitFeedback() {
    this.exitIntentForm = {
      ...this.exitIntentForm,
      motorLinkId: this.data.motorLinkId,
      systemLOVId: this.selectedReasonId,
      customReason: this.customReason
    };

    this.motorDataDataService
      .submitExitIntentFeedback(this.exitIntentForm)
      .subscribe(
        (result) => {
          if (result != null) {
            this.currentStep = 3; // Show thank you step
          }
          this.isSubmitting = false;
        },
        (error) => {
          this.isSubmitting = false;
        }
      );
  }

  getReasonListFromSystemLOV() {
    this.motorDataDataService
      .getSystemLOVByType("EXIT_INTENT_REASON")
      .subscribe((result) => {
        console.log({result});
        this.reasonList = result.sort((a, b) => a.seq - b.seq);
      });
  }

  close() {
    this.dialogRef.close(true);
  }

  continue() {
    this.continueForm.emit(true);
    this.dialogRef.close(true);
  }
}
